import { Container, Row } from "reactstrap";
import LeftSidebar from "../Common/LeftSidebar";
import ApplyForm from "./ApplyForm";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ApplyButton, JobSearch } from "../../../../Constants/Constants";

const ApplyJobsContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={ApplyButton} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <ApplyForm />
        </Row>
      </Container>
    </>
  );
};
export default ApplyJobsContainer;
